import { Redirect, Switch, Route } from 'react-router-dom';
import Login from '../pages/components/Auth/Login/Login';
import ForgotPassword from '../pages/components/Auth/Login/Forgot-Password/ForgotPassword';
import CreateNewPassword from '../pages/components/Auth/Create-New-Password/CreateNewPassword';
import Signup from '../pages/components/Auth/Signup/Signup';
import VerificationCode from '../pages/components/Auth/Login/Forgot-Password/Verification-Code/VerificationCode';
// import EmailVerification from '../pages/components/Auth/Signup/EmailVerifiction/EmailVerification';
import EnterPinCode from '../pages/components/Auth/Login/Enter-Pin-Code/EnterPinCode';
import ForgetPinCode from '../pages/components/Auth/Login/Forget-Pin-Code/ForgetPinCode';
import SendPinCode from '../pages/components/Auth/Login/send-pin-code/SendPinCode';
import EmergencyPinCode from '../pages/components/Auth/Signup/Emergency-Pin-Code/EmergencyPinCode';
import TermsAndConditions from '../pages/components/TermsAndConditions/TermsAndConditions';
import PrivacyPolicy from '../pages/components/PrivacyPolicy/PrivacyPolicy';
import MasterPublicLayout from "../layout/MasterPublicLayout";
import AccountDeletionInstructions from '../pages/components/AccountDeleteInstructions/AccountDeleteInstructions';

const PublicRoutes = () => {
    return (
        <MasterPublicLayout>
            <Switch>
                <Route path="/auth/login" component={Login} />
                <Route path='/auth/forgot-password' component={ForgotPassword} />
                <Route path='/auth/verification-code' component={VerificationCode} />
                <Route path='/auth/create-new-password' component={CreateNewPassword} />
                <Route path='/auth/enter-pin-code' component={EnterPinCode} />
                <Route path='/auth/forget-pin-code' component={ForgetPinCode} />
                <Route path='/auth/send-pin-code' component={SendPinCode} />
                <Route path='/auth/emergency-pin-code' component={EmergencyPinCode} />
                <Route path='/auth/create-an-account' component={Signup} />
                <Route path="/terms-and-conditions" component={TermsAndConditions} />
                <Route path="/privacy-policy" component={PrivacyPolicy} />
                <Route path="/data-deletion-instructions" component={AccountDeletionInstructions} />
                <Redirect to='/auth/login' />
            </Switch>
        </MasterPublicLayout>
    )
}

export default PublicRoutes